"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resultVehicleIdsReducer = void 0;
const resultVehicleIds_1 = require("../actions/resultVehicleIds");
const initState = [];
const resultVehicleIdsReducer = (vehicleIdsArray = initState, action) => {
    switch (action === null || action === void 0 ? void 0 : action.type) {
        case resultVehicleIds_1.ADD_RESULT_VEHICLE_IDS:
            return [...new Set([...vehicleIdsArray, ...action.payload])];
        case resultVehicleIds_1.SET_RESULT_VEHICLE_IDS:
            return [...action.payload];
        case resultVehicleIds_1.DELETE_RESULT_VEHICLE_IDS:
            return [];
        default:
            return vehicleIdsArray;
    }
};
exports.resultVehicleIdsReducer = resultVehicleIdsReducer;
//# sourceMappingURL=resultVehicleIdsReducer.js.map